const React = require('react')

module.exports = { 
      attributes: {"metaTitle":"Rate Estimate","metaDescription":"Use the rate calculator below to get an estimate. If you need a customer specific estimate then please give us a call at 303-295-0300 and ask to speak with an account executive.","title":"Rate Estimate","supportEmail":"support@nopk.biz"},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
}, /*#__PURE__*/React.createElement("p", null, "Use the *rate calculator below to get an estimate. If you need a customer-specific estimate then please give us a call at 303-295-0300 and ask to speak with an account executive Mon-Fri 8am-9pm MST."), /*#__PURE__*/React.createElement("p", null, "*This estimate gives general estimates and does not include other accessorial charges such as extended delivery locations, etc."), /*#__PURE__*/React.createElement("p", null, "If the shipment occupies more than 14 feet of trailer space, additional charges will apply. Please call the terminal for details."));
        return markdown
      }
    ,
     }